<template>
  <SectionFrame v-if="pairs.length || inStudio" :section="section" :index="index" :heading="heading" label="Before and after">
    <template v-if="pairs.length">
      <div :class="layout === 'stacked' ? 's2-ba-stack' : (layout === 'pairs' ? 's2-grid' : 's2-ba-sliders')" :style="layout === 'pairs' ? {'--s2-cols': 2} : null">
        <figure v-for="(p, i) in pairs" :key="i" class="s2-ba mo-reveal">
          <!-- Slider: the shared slider (S2's, also used by the before-after block). -->
          <BeforeAfterSlider v-if="layout === 'slider'" :before="p.beforeUrl" :after="p.afterUrl"
                             :labels="{before: 'Before', after: 'After'}" />
          <div v-else class="s2-ba-two">
            <div class="s2-ba-side"><img :src="p.beforeUrl" v-bind="imgAttrs(p.beforeUrl, '(min-width: 768px) 50vw, 100vw')" :alt="p.caption ? `Before: ${p.caption}` : 'Before'" loading="lazy" class="t-photo s2-ba-img">
              <span v-if="section.labels !== false" class="t-badge s2-ba-tag">Before</span></div>
            <div class="s2-ba-side"><img :src="p.afterUrl" v-bind="imgAttrs(p.afterUrl, '(min-width: 768px) 50vw, 100vw')" :alt="p.caption ? `After: ${p.caption}` : 'After'" loading="lazy" class="t-photo s2-ba-img">
              <span v-if="section.labels !== false" class="t-badge s2-ba-tag">After</span></div>
          </div>
          <figcaption v-if="p.caption" class="s2-muted s2-small">{{ p.caption }}</figcaption>
        </figure>
      </div>
    </template>
    <StudioGap v-else>Choose a before and an after photo (from your library or a job).</StudioGap>
  </SectionFrame>
</template>

<script setup>
import {imgAttrs} from "@/utils/photoSizes.js";
import {computed} from "vue";
import BeforeAfterSlider from "./shared/BeforeAfterSlider.vue";
import SectionFrame from "./SectionFrame.vue";
import StudioGap from "./StudioGap.vue";
import {layoutOf, listOf} from "@/utils/sectionLogic.js";
import {studioMode} from "@/classes/previewBridge.js";

const props = defineProps({section: {type: Object, required: true}, index: {type: Number, default: 0}});
const inStudio = computed(() => studioMode.value !== "off");
const layout = computed(() => layoutOf(props.section, ["slider", "pairs", "stacked"]));
const heading = computed(() => props.section.heading ?? "Before and after");
const draft = (m) => (import.meta.env.VITE_IS_PREVIEW_SERVER === "true" ? m?.displayUrl : "");
const url = (m) => (typeof m === "string" ? m : draft(m) || m?.url || m?.image?.url || "");
const pairs = computed(() => listOf(props.section.pairs, 8)
  .map((p) => ({beforeUrl: p.beforeUrl || url(p.before), afterUrl: p.afterUrl || url(p.after), caption: String(p.caption || "")}))
  .filter((p) => p.beforeUrl && p.afterUrl));
</script>

<style>
.s2-ba { margin: 0; }
.s2-ba-sliders { display: grid; gap: var(--t-gap); grid-template-columns: repeat(auto-fit, minmax(min(100%, 420px), 1fr)); }
.s2-ba-stack { display: grid; gap: calc(var(--t-gap) * 1.5); }
.s2-ba-tag { position: absolute; top: .75rem; pointer-events: none; }
.s2-ba-two { display: grid; grid-template-columns: 1fr 1fr; gap: .5rem; }
.s2-ba-side { position: relative; } .s2-ba-tag { left: .5rem; }
.s2-ba figcaption { margin-top: .5rem; }
</style>
